import { TIMESHEET_APPLICANT_STATUSES } from "./constants";

export const getTimesheetStatusOptions = (statusLabels = {}) =>
  [
    TIMESHEET_APPLICANT_STATUSES.approved,
    TIMESHEET_APPLICANT_STATUSES.removed,
    TIMESHEET_APPLICANT_STATUSES.cancelled,
  ].map((id) => ({
    id,
    name: statusLabels[id] || id,
  }));
